import { observer } from '@rehaje/reactive-react'

import type { SchemaModel } from '../models/SchemaModel'
import type { SchemaNode } from '../models/SchemaNode'
import type { VC } from '@rehaje/react'

export const SchemaView: VC<SchemaNode, SchemaModel> = observer(({ model }) => {
  if (!model) return
  return model.render()
})
